/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Component, ElementRef, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core'
import { FooterEnvironment, PidArtFooterComponent } from '@porsche-customer/pid-art-footer-angular'
import { environment } from '../../../environments/environment'
import { ConfigService } from '../../services/config/config.service'
import { FooterHeightService } from '../../services/footer-height/footer-height.service'

@Component({
  selector: 'myprofile-signup-ui-footer',
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [PidArtFooterComponent],
})
export class FooterComponent implements OnInit, OnDestroy {
  private configService = inject(ConfigService)
  private footerHeightService = inject(FooterHeightService)
  private elementRef = inject(ElementRef)
  private resizeObserver?: ResizeObserver

  readonly country = this.configService.getUrlCountry()
  readonly locale = this.configService.getUrlLocale()
  readonly footerEnvironment = environment.navigationOptions.environment as FooterEnvironment

  ngOnInit() {
    this.resizeObserver = new ResizeObserver((entries) => {
      const height = entries[0]?.contentRect.height ?? 0
      this.footerHeightService.setHeight(height)
    })
    this.resizeObserver.observe(this.elementRef.nativeElement)
  }

  ngOnDestroy() {
    this.resizeObserver?.disconnect()
    this.footerHeightService.setHeight(0)
  }
}
